import React from 'react';
import {observer} from 'mobx-react-lite';
import {
    AccountDataSection,
    ConsentsSection,
    DocumentsSection,
    IntegrationsSection,
} from '../PrivacyCenterPage';

const ProfilePrivacyPage: React.FC = () => (
    <div className="space-y-6">
        <ConsentsSection/>
        <DocumentsSection/>
        <IntegrationsSection/>
        <AccountDataSection/>
    </div>
);

export default observer(ProfilePrivacyPage);
